
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","d":"M20.069 18.353a.835.835 0 00.193-.537c0-.5-.501-.975-.94-1.423-1.011-1.23-1.336-1.952-1.424-3.894-.106-3.612-1.073-5.722-3.34-6.46C14.303 4.861 13.398 4 12.176 4c-1.222 0-2.127.861-2.373 2.04a3.739 3.739 0 00-1.406.755l.782.782a2.959 2.959 0 011.134-.58c.255-.07.404-.184.422-.422.07-.905.597-1.573 1.441-1.573.853 0 1.38.668 1.441 1.573.027.237.167.352.422.422 1.574.43 2.646 1.793 2.778 5.45.105 1.581.21 2.399.738 3.207l2.514 2.699zm.808 3.014a.51.51 0 000-.738L4.9 4.65a.528.528 0 00-.747 0 .536.536 0 000 .747l15.987 15.97a.51.51 0 00.738 0zm-8.701.484c1.67 0 2.865-1.275 2.98-2.866h1.256l-1.151-1.16h-9.95v-.096c.106-.352.695-.976 1.196-1.521.8-.861.95-2.426 1.108-4.271.035-.58.096-1.1.193-1.565l-.94-.94c-.185.703-.29 1.511-.335 2.4-.149 1.379-.22 2.961-.931 3.734-.738.783-1.591 1.547-1.591 2.435 0 .527.37.853 1.037.853h4.14c.061 1.643 1.274 2.997 2.988 2.997zm0-.958c-1.081 0-1.863-.791-1.925-2.04h3.859c-.062 1.249-.853 2.04-1.934 2.04z","fill-rule":"evenodd"}})])
          )
        }
      }
    